var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useMutation } from '@apollo/client';
import { callSideEffects } from '../../util';
import { TRIP_STATE_FRAGMENT } from '../tripstate';
const UPDATE_HOLIDAY_FLIGHT_MUTATION = gql `
    mutation UpdateHolidayFlightMutation($request: updateHolidayFlightRequest) {
        updateHolidayFlight(request: $request) {
            ... on TripState {
                ${TRIP_STATE_FRAGMENT}
            }
          
        }
    }
`;
export function useUpdateHolidayFlight(sideEffects, errorSideEffects) {
    const [updateHolidayFlightMutation, updateHolidayFlightResult] = useMutation(UPDATE_HOLIDAY_FLIGHT_MUTATION, {
        onError: (err) => {
            callSideEffects(errorSideEffects, err);
        },
        onCompleted: (data) => {
            callSideEffects(sideEffects, data);
        },
    });
    const updateHolidayFlight = (args) => __awaiter(this, void 0, void 0, function* () {
        yield updateHolidayFlightMutation({
            variables: args,
        });
    });
    return [updateHolidayFlight, updateHolidayFlightResult];
}
